export const hero = `
<div class="w-full m-auto px-2 lg:px-6 py-5 space-y-4 mt-20">
  <!-- Top Hero Section -->
  <section class="bg-white relative overflow-hidden">
    <header class="w-full  m-auto px-2 lg:px-6 py-5 space-y-4 mt-0 lg:mt-40">
      <div class=" relative">
        <!-- Left Content -->
        <div
          class="max-w-xl text-start lg:text-left space-y-6 mt-0 lg:-mt-36"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <h1 class="text-4xl md:text-4xl font-bold text-[#4A2F7E] ml-0 lg:ml-20">
            Your Key to the <br />
            World of
            <span class="" style="border-bottom: 6px solid rgb(21, 98, 229)">
              Finance</span
            >
          </h1>
          <p class="text-sm text-gray-900 font-light ml-0 lg:ml-20"">
           We are a tech-enabled, widely accessible platform for raising funds for businesses by serving as a perfect bridge between borrowers and lenders. 

           <br/>
           <br/>
           Our proprietary technology is built around the complex world of fund-raising to make the whole process faster and easier. 
          </p>

          <button
          onclick="document.getElementById('signupModal').showModal()"
            class="w-3xs flex group relative inline-block overflow-hidden bg-blue-100 text-white rounded-full cursor-pointer ml-0 lg:ml-20""
          >
            <span>
              <span
                class="absolute inset-0 flex items-center px-5 text-blue-800 transition-transform duration-300 translate-y-0 group-hover:-translate-y-full"
              >
                Get Started
              </span>
              <span
                class="absolute inset-0 flex items-center px-5 text-blue-800 transition-transform duration-300 translate-y-full group-hover:translate-y-0"
              >
                Get Started
              </span>
            </span>
            <span
              class="text-xl relative float-right w-12 h-12 rounded-full flex justify-center items-center bg-blue-700 text-white"
            >
              <span
                class="flex items-center absolute inset-0 font-light left-4 transition-transform duration-300 translate-y-0 group-hover:-translate-y-full"
              >
                <i class="fa-solid fa-arrow-up rotate-45"></i>
              </span>
              <span
                class="flex items-center absolute inset-0 left-4 transition-transform duration-300 translate-y-full group-hover:-translate-y-0"
              >
                <i class="fa-solid fa-arrow-up rotate-45"></i>
              </span>
            </span>
          </button>

        </div>
        <div
          style="clip-path: polygon(0% 0%, 85% 0%, 85% 100%, 16% 100%)"
          class="group z-10 w-[70dvw] md:w-[65dvw] lg:w-[60dvw] xl:w-[65dvw] 2xl:w-[50dvw] hidden lg:block absolute left-[40%] -top-10"
        >
          <img
            src="https://ibankeystaticstorage.blob.core.windows.net/cdnfiles/website/iphone-ibankey.png"
            alt="Ibankey"
            class="object-cover transform transition-transform duration-300"
          />
        </div>
      </div>
    </header>

    <!-- group-hover:-translate-x-2 group-hover:translate-y-1 -->
    <!-- Blue Bottom Section -->
    <div
      class=" w-ful lg:w-[90%] m-auto bg-gradient-to-br from-blue-700 to-blue-500 rounded-3xl pt-12 pb-16 px-6 relative z-0 mt-10"
    >
      <!-- Scrolling marquee text inside the blue section -->
      <div class="overflow-hidden whitespace-nowrap mb-6">
        <marquee>
          <div
            class="inline-block animate-marquee text-white/60 font-bold text-xl lg:text-8xl tracking-wider"
          >
            ibankey: Seamless Platform. Powering Finance. Enabling Futures 
          </div>
        </marquee>
      </div>

      <!-- Blue section content -->
      <div class="text-center text-white w-full mx-auto">
        <marquee direction="left" loop="infinity">
          <div
            class="flex justify-center animate-marquee gap-6 mt-6 opacity-80 text-sm"
          >
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> <span>HDFC Bank</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> State Bank of India (SBI)</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Northern Arc</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> Kotak Mahindra Bank</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Axis Bank</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Axis Finance</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> RBL Bank</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> IndusInd Bank</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>TATA Capital </span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>HSBC</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Sundaram Alternates </span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> Bank of India </span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Canara Bank</span></span>

            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Punjab National Bank (PNB)</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i> Canara Bank</span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Union Bank of India </span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Indian Overseas Bank </span></span>

            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>Yes Bank </span></span>
            <span class="flex gap-1 items-center"><i class="fa-solid fa-building-columns"></i>ICICI Bank</span></span>
           
          </div>
        </marquee>
      </div>
    </header>
  </section>
</div>
`;
